import { useEffect } from "react";
import { useUiStore, type BreadcrumbEntry } from "../store/uiStore";

/**
 * Sets the breadcrumb and moves focus to the H1 on mount (page views are
 * tracked automatically by the shared telemetry setup). Callers memoize `breadcrumb` so the effect only re-runs on real changes.
 */
export function usePageSetup(pageName: string, breadcrumb: readonly BreadcrumbEntry[] | null): void {
  const setBreadcrumb = useUiStore((state) => state.setBreadcrumb);

  useEffect(() => {
    setBreadcrumb(breadcrumb ?? []);
    return () => setBreadcrumb([]);
  }, [setBreadcrumb, breadcrumb]);

  useEffect(() => {
    const heading = document.querySelector<HTMLElement>("main h1");
    heading?.setAttribute("tabindex", "-1");
    heading?.focus({ preventScroll: true });
  }, [pageName]);
}
